import React from 'react';
import {RxForm, FormManager, FormField, FormRow, Multiform} from 'reactis-forms';
import {TextInput, TextArea, DatePicker, RadioList, FileUpload, ImageUpload, Select, Checkbox, Number} from 'reactis-inputs';
import {AlertWindow, ConfirmWindow} from 'reactis-modal';
import {Loader, LoadingButton} from 'reactis-loader';

export default class DocumentSubform extends React.Component {

	static contextTypes= {
		router: React.PropTypes.object
	};

	constructor(props) {
		super(props);
		this.state = {
			overRemove: false
		}
	}

	handleMouseOver() {
		this.setState({overRemove: true});
	}

	handleMouseOut() {
		this.setState({overRemove: false});
	}

	render() {
		const values = this.props.state.get('values').toJS();
		return (
			<tr className={this.state.overRemove ? 'subformOverRemove' : null}>
				<td style={{padding:'0px 4px', fontStyle:'italic', color: '#999'}}>{values.fTitle}</td>
				<td style={{padding:'0px 10px'}}>{values.title}</td>
				<td style={{padding:'0px 4px'}}><i title="Odstranit"
				       onClick={this.props.onRemove}
				       onMouseOver={() => this.handleMouseOver()}
				       onMouseOut={() => this.handleMouseOut()}
				       className="icon-cross removesubform"/>
				</td>
			</tr>
		)
	}
}



// WEBPACK FOOTER //
// ./src/containers/Document/DocumentSubform.js